import type { IFilters } from '@/types/shared/filters'
import type { InfrastructureType } from '../SiteMap'

export enum SiteReportType {
  TABLE = 'TABLE',
  DOWNTIME = 'DOWNTIME',
  BASELINE = 'BASELINE',
}

export enum HostingClientReportType {
  UPTIME = 'UPTIME',
  BILLING = 'BILLING',
}

export enum InfrastructureReportType {
  UPTIME = 'UPTIME',
}

export interface IEnergyBillEstimationFilters extends IFilters {
  site: string | undefined
  month: number | undefined
  year: number | undefined
}
export interface IEnergyBillEstimationGenerationFilters {
  site: string
  period: Date
  response_format: string
}

export interface IResourceSearchFilters {
  resource: string
  fragment: string
  limit?: number
  customers_with_work_orders?: boolean
}

export interface ISiteCurtailmentConfigurationFilters extends IFilters {
  site_id?: string
}

// Site Map filters
export interface ISiteMapStructureFilters extends IFilters {
  site_id?: string
  name?: string
  active_at?: string
  operational?: boolean
}

export interface ISiteMapRackFilters extends IFilters {
  site_id?: string
  structure_id?: string
  structure_ids?: string // Comma separated list of structure ids
  name?: string
  active_at?: string
  operational?: boolean
}

export interface ISiteMapMinerFilters extends IFilters {
  site_id?: string
  structure_id?: string
  rack_id?: string
  hosting_client_id?: string
  name?: string
  ip?: string
  tags?: string
}

export interface IHostingClientFilters extends IFilters {
  name?: string
}

export interface IDowntimeFilters extends IFilters {
  site_id?: string
  structure_id?: string
  rack_id?: string
  downtime_type_ids?: string
  from_datetime?: string
  to_datetime?: string
  dispatch_id?: string
}

export interface IClientDowntimeSummaryFilters {
  name?: string
  start_datetime: string
  end_datetime: string
}

export interface IInfrastructureDowntimeSummaryFilters {
  site_id?: string
  name?: string
  start_datetime: string
  end_datetime: string
}

export interface IMinersDowntimeSummaryFilters extends IInfrastructureDowntimeSummaryFilters, IFilters {
  hosting_client_id?: string
  models?: string
  tags?: string
}

export interface IMinersDowntimeSummaryExportFilters extends IMinersDowntimeSummaryFilters {
  type: 'period' | 'hourly'
}

export interface IDowntimeClientDetailSummaryFilters {
  start_datetime: string
  end_datetime: string
}

export interface ISiteReportFilters {
  start_datetime: string
  end_datetime: string
  type: SiteReportType
}

export interface IHostingClientsReportFilters {
  month: number
  year: number
  type: HostingClientReportType
  hosting_client_id?: string
  hosting_client_name?: string
  timezone?: string
}

export interface IInfrastructureReportFilters {
  month: number
  year: number
  type: InfrastructureReportType
  infrastructure_type: InfrastructureType
}

export interface INBPTThresholdFilters extends IFilters {
  iso?: string
  month?: number
  year?: number
}

export interface IPPAFilters {
  site?: string
  active_only?: boolean
}

export interface ISubmeterFilters extends IFilters {
  site_id?: string
}

export interface ISubmeterReportFilters {
  month: number
  year: number
  device_name: string
}

export interface ISiteDispatchFilters extends IFilters {
  site_id?: string
  date?: string // YYYY-MM-DD
  dispatch_id?: string
  program_name?: string
}
